import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

import CenteredWrapper from 'ui/CenteredWrapper';
import Heading from 'ui/Heading';
import { FlexItem, HR } from 'components/forms/Forms.styles';
import BlogDetailsFrom from './BlogDetailsForm';
import AccessDenied from 'components/AccessDenied';

const CreateBlogPage = () => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const isAdmin = useSelector((state) => state.user.isAdmin);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues = {
    title: '',
    content: '',
    imageUrl: '',
    videoUrl: '',
    category: '',
    isFeatured: false,
    tags: [''],
  };
  const createBlog = async (values, status) => {
    // console.log('create blog with values: ', values);
    api
      .post(`${API_BASE}/api/blog/create`, { ...values, status })
      .then((res) => {
        if (res.status == 200) {
          const blogId = res.data?.data;
          navigate(`/edit-blog/${blogId}`);
        }
      })
      .catch(() => alert('Failed to create a new essay prompt.'))
      .finally(() => setIsSubmitting(false));
  };

  if (!isAuthenticated || !isAdmin) {
    return <AccessDenied />;
  }

  return (
    <CenteredWrapper
      display="flex"
      justifyContent="start"
      flexDirection="column"
      mt="80px"
      minHeight="calc(100vh - 180px)"
      maxWidth="900px"
    >
      <FlexItem>
        <Heading variant="h2">New Blog</Heading>
      </FlexItem>
      <HR className="light" />
      <BlogDetailsFrom
        data={initialValues}
        updateBlog={createBlog}
        isDisabled={isSubmitting}
        isEdit={false}
      />
    </CenteredWrapper>
  );
};

export default CreateBlogPage;
